<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-input v-model="query.no" placeholder="business.label.no" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query.name" placeholder="business.label.name" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-select v-model="query.operationType" :options="operationTypes" placeholder="business.label.operationType" @change="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button content="button.add" icon="vxe-icon-add" status="primary" @click="add"/>
      </template>
      <vxe-table ref="table" :data="data" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="no" fixed="left" title="business.label.no" width="100"/>
        <vxe-column field="name" fixed="left" title="business.label.name" width="100"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:orderTypes}" field="parent.name" fixed="left" title="business.label.parent" width="100"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:operationTypes}" field="operationType" fixed="left" title="business.label.operationType" width="80"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="available" fixed="left" title="business.label.available" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="original" fixed="left" title="business.label.native" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="refundable" title="business.label.refundable" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="depositable" title="business.label.depositable" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="coding" title="business.label.coding" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="chargeup" title="business.label.chargeup" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="inspectable" title="business.label.inspectable" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="producible" title="business.label.producible" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="shortable" title="business.label.shortable" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="delegable" title="business.label.delegable" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="exchangeable" title="business.label.exchangeable" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="invertible" title="business.label.invertible" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="convertible" title="business.label.convertible" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="supplemental" title="business.label.supplemental" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="temporary" title="business.label.temporary" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="supervised" title="business.label.supervised" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="mergeOrder" title="business.label.mergeOrder" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="autoSubmit" title="business.label.autoSubmit" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="autoApproval" title="business.label.autoApproval" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="autoAsn" title="business.label.autoAsn" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="autoReceiving" title="business.label.autoReceiving" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="autoAccepting" title="business.label.autoAccepting" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="autoPutaway" title="business.label.autoPutaway" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="autoCompletion" title="business.label.autoCompletion" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="autoRetry" title="business.label.autoRetry" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="autoInversionApproval" title="business.label.autoInversionApproval" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="autoReview" title="business.label.autoReview" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="autoDistribution" title="business.label.autoDistribution" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="autoHandover" title="business.label.autoHandover" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="autoCleanup" title="business.label.autoCleanup" width="60"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row,false)"/>
            <vxe-button content="button.copy" icon="vxe-icon-copy" status="primary" @click.stop="edit(row,true)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
    <order-type-editor ref="editor" :operation-types="operationTypes" :order-types="orderTypes" @success="refresh"/>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'
import { OrderType } from '@/api/dto/common/OrderType'
import { getEnums, getOptions } from '@/utils/util'
import OrderTypeEditor from '@/views/basedata/orderType/OrderTypeEditor.vue'

export default {
  name: 'OrderTypeMaintain',
  components: { OrderTypeEditor },
  data() {
    return {
      loading: false,
      data: [],
      query: new OrderType(),
      page: 1,
      size: 20,
      contentSize: 0,
      orderTypes: [],
      operationTypes: []
    }
  },
  created() {
    findAll('orderTypeFactory', { available: true }).then(res => {
      if (res.success) {
        this.orderTypes = getOptions(res.result)
      }
      return getEnums('OperationType')
    }).then(result => {
      this.operationTypes = result
    }).finally(() => this.refresh())
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      findAll('orderTypeFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = new OrderType()
      this.refresh()
    },
    add() {
      this.$refs.editor.add()
    },
    edit(row, copy) {
      this.$refs.editor.edit(row.id, copy)
    }
  }
}
</script>